<template>
        <up-low-paging @pageChange="pageChange" :pagingInfo="pagingInfo">
            <Loading :show="isLoading"></Loading>
            <slot></slot>
        </up-low-paging>
</template>
<script>
    import UpLowPaging from './UpLowPaging.vue';
    import Loading from './Loading.vue';
    export default {
        components: {
            UpLowPaging: UpLowPaging,
            Loading: Loading
        },
        props: ["isLoading","pagingInfo"],
        methods: {
            pageChange: function (page) {
                this.$emit('pagechange', page);
            }
        },
        created: function () {
            console.log("paged loading created");
        },
        mounted: function () {
            console.log("paged loading mounted");
        }

    }
</script>